module.exports = __webpack_public_path__ + "media/decathlon-backschool.a77772fb.mp4";